import React from 'react'
import PortableText from '@sanity/block-content-to-react'

import HeroTypographic from '../hero/typographic/heroTypographic'
import HeroVideo from '../hero/video/heroVideo'
import HeroImage from '../hero/image/heroImage'
import Chequerboard from '../chequerboard/chequerboard'
import ChequerboardGroup from '../chequerboard/group/chequerboardGroup'
import FeaturedWorkItem from '../featuredWork/item/featuredWorkItem'
import FeaturedWorkBlock from '../featuredWork/block/featuredWorkBlock'
import Pullquote from '../pullquote/pullquote'
import InstagramFeed from '../instagram/instagramFeed'
import SingleColFeature from '../singleColFeature/singleColFeature'
import Image from '../image/image'
import CaseStudiesListBlock from '../caseStudiesList/block/caseStudiesListBlock'
import CaseStudySection from '../caseStudySection/caseStudySection'
import CaseStudyQuote from '../caseStudyQuote/caseStudyQuote'
import ImageGrid from '../imageGrid/imageGrid'
import NewsletterSignup from '../newsletterSignup/newsletterSignup'
import IntroBlock from '../introBlock/introBlock'
import CoreCompetencies from '../coreCompetencies/coreCompetencies'
import ClientsList from '../clientsList/clientsList'
import JoinUs from '../joinUs/joinUs'

const serializers = {
  types: {
    heroTypographic: props => <HeroTypographic data={props.node}></HeroTypographic>,
    heroVideo: props => <HeroVideo data={props.node}></HeroVideo>,
    heroImage: props => <HeroImage data={props.node}></HeroImage>,
    chequerboard: props => <Chequerboard data={props.node}></Chequerboard>,
    chequerboardGroup: props => <ChequerboardGroup data={props.node}></ChequerboardGroup>,
    caseStudy: props => <FeaturedWorkItem data={props.node}></FeaturedWorkItem>,
    featuredWorkBlock: props => <FeaturedWorkBlock data={props.node}></FeaturedWorkBlock>,
    pullquote: props => <Pullquote data={props.node}></Pullquote>,
    instagramFeed: props => <InstagramFeed data={props.node}></InstagramFeed>,
    singleColFeature: props => <SingleColFeature data={props.node}></SingleColFeature>,
    image: props => <Image file={props.node}></Image>,
    contentImage: props => <Image file={props.node.image} alt={props.node.alt}></Image>,
    caseStudiesListBlock: props => <CaseStudiesListBlock data={props.node}></CaseStudiesListBlock>,
    caseStudySection: props => <CaseStudySection data={props.node}></CaseStudySection>,
    caseStudyQuote: props => <CaseStudyQuote data={props.node}></CaseStudyQuote>,
    imageGrid: props => <ImageGrid data={props.node}></ImageGrid>,
    newsletterSignup: props => <NewsletterSignup data={props.node}></NewsletterSignup>,
    introBlock: props => <IntroBlock data={props.node}></IntroBlock>,
    coreCompetencies: props => <CoreCompetencies data={props.node}></CoreCompetencies>,
    clientsList: props => <ClientsList data={props.node}></ClientsList>,
    joinUs: props => <JoinUs data={props.node}></JoinUs>,
  },
}

const BlockContent = ({ input }) => (
  <PortableText blocks={input} serializers={serializers}></PortableText>
)

export default BlockContent
